// SubscriptionPage.jsx
import {useEffect, useState} from 'react';
import {loadStripe} from '@stripe/stripe-js';
import {Elements} from '@stripe/react-stripe-js';
import axios from 'axios';
import {Spinner} from 'react-bootstrap';
import {getAccessToken, getUser} from '../services/AuthService';
import {showErrorNotification} from '../services/notificationService';
import SubscriptionForm from './SubscriptionForm';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export default function SubscriptionPage({ isLoggedIn, selectedPriceId, trialDays, selectDefaultPaymentMethod }) {
  const [clientSecret, setClientSecret] = useState('');
  const [mode, setMode] = useState(null); // 'setup' | 'payment'

  useEffect(() => {
    (async () => {
      if (!selectedPriceId) return;

      const hasTrial = Array.isArray(trialDays) && trialDays.length > 0 && Number(trialDays[0]?.days) > 0;
      setMode(hasTrial ? 'setup' : 'payment');

      try {
        const token = getAccessToken();
        const headers = { Authorization: `Bearer ${token}` };
        const user = getUser();

        if (hasTrial) {
          const { data } = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/api/stripe/setup-intent/`,
            { customer_id: user.stripe_customer_id },
            { headers, timeout: 5000 }
          );
          setClientSecret(data.client_secret);
        } else {
          const { data } = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/api/stripe/create-subscription-intent/`,
            { price_id: selectedPriceId, customer_id: user.stripe_customer_id },
            { headers, timeout: 5000 }
          );
          setClientSecret(data.client_secret);
        }
      } catch (e) {
        showErrorNotification(e);
      }
    })();
  }, [selectedPriceId, trialDays]);

  if (!clientSecret) {
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ minHeight: 160 }}
      >
        <Spinner animation="border" role="status" />
        <span className="ms-2">Preparando el pago…</span>
      </div>
    );
  }

  return (
    <Elements stripe={stripePromise} options={{ clientSecret }} key={clientSecret}>
      <SubscriptionForm
        isLoggedIn={isLoggedIn}
        selectedPriceId={selectedPriceId}
        trialDays={trialDays}
        selectDefaultPaymentMethod={selectDefaultPaymentMethod}
        mode={mode}
        clientSecret={clientSecret}
      />
    </Elements>
  );
}
